const UNAUTHORIZED = '401';
export default UNAUTHORIZED;
